__turbopack_context__.v({
  "product-header": "zsZ4QW_product-header",
  "product-header__content": "zsZ4QW_product-header__content",
  "product-header__detail": "zsZ4QW_product-header__detail",
  "product-header__heading": "zsZ4QW_product-header__heading",
  "product-header__image": "zsZ4QW_product-header__image",
  "product-header__logo": "zsZ4QW_product-header__logo",
  "product-header__price": "zsZ4QW_product-header__price",
  "product-header__price-info": "zsZ4QW_product-header__price-info",
  "product-header__tagline": "zsZ4QW_product-header__tagline",
});
